import axios from 'axios';

// Acessando por outro endereço (ex.: IP da rede), "localhost" apontaria para a máquina de quem
// abriu a página: usa o mesmo host da página, mantendo a porta da API.
const resolveApiUrl = (): string => {
    const configured = process.env.REACT_APP_API_URL || 'http://localhost:5001';
    try {
        const url = new URL(configured);
        const pageHost = window.location.hostname;
        const isLocal = (host: string) => ['localhost', '127.0.0.1', '[::1]'].includes(host);
        if (isLocal(url.hostname) && pageHost && !isLocal(pageHost)) {
            url.hostname = pageHost;
            return url.toString().replace(/\/$/, '');
        }
    } catch {
        // URL relativa ou inválida: usa como está
    }
    return configured;
};

const api = axios.create({
    baseURL: resolveApiUrl(),
    headers: {
        'Content-Type': 'application/json',
    },
    transformResponse: [(data) => {
        // Tenta fazer o parse da resposta se for uma string
        if (typeof data === 'string') {
            try {
                // Substitui "Infinity" por um número muito grande antes do parse
                const jsonString = data.replace(/:Infinity/g, ':1e308');
                return JSON.parse(jsonString);
            } catch (e) {
                console.error('Erro ao fazer parse da resposta:', e);
                return data;
            }
        }
        return data;
    }]
});

// Interceptor para adicionar o token de autenticação
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('@App:token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    console.error('Erro na requisição:', error);
    return Promise.reject(error);
});

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // 401 no próprio login é "credenciais inválidas", tratado pelo formulário — não é sessão expirada
        const isLoginRequest = String(error.config?.url || '').includes('/api/auth/login');
        if (error.response?.status === 401 && !isLoginRequest) {
            // Limpa o token e usuário do localStorage
            localStorage.removeItem('@App:token');
            localStorage.removeItem('@App:user');
            
            // Salva a mensagem de erro para ser exibida após o redirecionamento
            const errorMessage = error.response?.data?.error || 'Sua sessão expirou. Por favor, faça login novamente.';
            sessionStorage.setItem('@App:authError', errorMessage);
            
            // Redireciona para a página de login
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api; 